import axiosInstance from "./AxiosInstance";

export const sendOTP = async (payload) => {
  const res = await axiosInstance.post("/patient/sendOTP", payload);
  return res.data;
};

export const verifyOTP = async (payload) => {
  const res = await axiosInstance.post("/patient/verifyOTP", payload);
  return res.data;
};

export const resolveForm = async ({ patient_id }) => {
  const res = await axiosInstance.post("/patient/resolve-form", { patient_id });
  return res.data;
};
